import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { BOOKING_URL } from "../data/site";
import { track } from "../lib/analytics";

export const CTASection = () => (
  <section data-testid="final-cta" className="py-24 sm:py-32 px-5 sm:px-8">
    <div className="max-w-6xl mx-auto rounded-3xl bg-navy relative overflow-hidden px-8 sm:px-16 py-16 sm:py-20">
      <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-teal/20 blur-3xl" />
      <div className="absolute -left-16 -bottom-16 h-64 w-64 rounded-full bg-emerald/20 blur-3xl" />
      <Reveal className="relative max-w-2xl">
        <p className="text-sm uppercase tracking-widest font-semibold text-white/70 mb-4">Get started today</p>
        <h2 className="font-heading text-3xl sm:text-5xl font-bold text-white tracking-tight leading-tight">
          Ready to make IT your competitive advantage?
        </h2>
        <p className="mt-5 text-lg text-slate-300">
          Book a free, no-obligation IT assessment. We'll review your infrastructure, security, and roadmap — and show you exactly where you stand.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer"
            onClick={() => track("book_intro_call_click", { location: "cta-section" })}
            data-testid="cta-booking-button"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-emerald hover:bg-emerald-dark text-white font-semibold transition-colors">
            Book an Intro Call <ArrowRight className="h-4 w-4" />
          </a>
          <Link
            to="/contact"
            data-testid="cta-book-button"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-white/10 hover:bg-white/20 text-white font-semibold transition-colors border border-white/20"
          >
            Request a Free IT Assessment
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
